import { createAction, props } from '@ngrx/store';
import { ErrorStore, SharedAnalysisResults } from '@sleipai/sleip-models';

export const loadSharedAnalysisResultsByIdAndPublicKey = createAction(
  '[SharedAnalysisResultsStrore] Load SharedAnalysisResults',
  props<{ publicRecordingId: string; publicKey: string; version: string }>()
);

export const loadSharedAnalysisResultsSuccess = createAction(
  '[SharedAnalysisResultsStrore] Load SharedAnalysisResults Success',
  props<{ data: SharedAnalysisResults }>()
);

export const loadSharedAnalysisResultsListSuccess = createAction(
  '[SharedAnalysisResultsStrore] Load SharedAnalysisResults List Success',
  props<{ data: SharedAnalysisResults[] }>()
);

export const loadSharedAnalysisResultsFailure = createAction(
  '[SharedAnalysisResultsStrore] Load SharedAnalysisResults Failure',
  props<{ error: ErrorStore | string | null | any }>()
);
